import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import ErrorMessage from '../../components/ErrorMessage';
import { logger } from '../../utils/logger';
import { checkAssessmentIsV2 } from '../assessment/api/checkAssessmentIsV2';
import AssessmentStep from './AssessmentStep';
import LoadingSection from './LoadingSection';
import { useSteps } from './StepsContext';
import V2AssessmentStep from './V2AssessmentStep';

type State =
  | {
      status: 'ready';
      isV2: boolean;
    }
  | {
      status: 'loading';
    }
  | {
      status: 'error';
      message: string;
    };

export default function AssessmentStepProxy() {
  const [{ currentStep }] = useSteps();
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading' });

    checkAssessmentIsV2(currentStep.task.assessmentId)
      .then(({ isV2 }) => {
        if (!cancelled) setState({ status: 'ready', isV2 });
      })
      .catch((error: AxiosError) => {
        if (cancelled) return;

        if (error.response?.status === 404) {
          setState({ status: 'ready', isV2: false });
        } else {
          logger.error('Failed to determine isV2: ', error);
          setState({ status: 'error', message: error.message });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [currentStep.id.id]);

  if (state.status === 'ready') return state.isV2 ? <V2AssessmentStep /> : <AssessmentStep />;
  if (state.status === 'error') return <ErrorMessage />;
  if (state.status === 'loading') return <LoadingSection />;
}
